import React from "react";
import footrer_bg from "../assets/footer_bg.png";
import logo from "../assets/logo.png";
import { FaFacebook } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";
import { AiFillInstagram } from "react-icons/ai";
import { Link } from "react-scroll"; // Import react-scroll for smooth scrolling

function Footer() {
  return (
    <div
      style={{ background: `url(${footrer_bg})`, backgroundSize: "contain" }}
      className=""
    >
      <div className="px-5 sm:px-16 md:px-28 py-10">
        <div className="flex justify-between flex-col lg:flex-row items-center gap-5 lg:gap-10">
          <div className="text-white text-3xl font-yeseva lg:text-start text-center">
            Subscribe To Our <br className="hidden lg:block" /> Newsletter
          </div>
          <div className="flex">
            <input
              type="text"
              placeholder="Enter your email"
              className="w-40 sm:w-auto px-3 sm:px-5 py-2 rounded-l outline-none"
            />
            <div className="bg-[#988D25] px-3 text-lg sm:text-xl font-yeseva text-white py-2 rounded-r hover:bg-[#988c25c9] cursor-pointer transition-all duration-300">
              Subscribe
            </div>
          </div>
        </div>

        <div className="flex justify-between flex-wrap gap-10 xl:pr-40 pt-10">
          <div>
            <div className="flex items-center gap-5">
              <img className="w-28" src={logo} alt="" />
              <p className="text-3xl font-yeseva text-white">My Wali</p>
            </div>
            <div className="text-white text-xl font-yeseva pb-3 pt-5">
              Follow Us On
            </div>
            <div className="flex gap-5 text-white text-3xl">
              <FaFacebook />
              <BsTwitterX />
              <AiFillInstagram />
            </div>
          </div>

          <div className="flex flex-col font-poppins gap-4 text-white text-lg">
            <Link
              to="home"
              smooth={true}
              duration={500}
              offset={-70}
              className="cursor-pointer"
            >
              Home
            </Link>
            <Link
              to="about"
              smooth={true}
              duration={500}
              offset={-70}
              className="cursor-pointer"
            >
              About Us
            </Link>
            <Link
              to="memberships"
              smooth={true}
              duration={500}
              offset={-70}
              className="cursor-pointer"
            >
              Memberships
            </Link>
            <Link
              to="faqs"
              smooth={true}
              duration={500}
              offset={-70}
              className="cursor-pointer"
            >
              FAQ's
            </Link>
            <Link
              to="contact"
              smooth={true}
              duration={500}
              offset={-70}
              className="cursor-pointer"
            >
              Contact Us
            </Link>
          </div>

          <div className="flex flex-col font-poppins gap-4 text-white text-lg">
            <a href="">Terms & Conditions</a>
            <a href="">Terms Of Service</a>
            <a href="">Privacy Policy</a>
          </div>
        </div>
      </div>

      <div className="bg-[#483375] h-14 w-full font-yeseva text-base text-white flex justify-center items-center">Supported by your Wali.
      </div>
    </div>
  );
}

export default Footer;
